/* 通用巨型菜单 hover-intent 修复(机制无关、零持久CSS、零布局影响)。
   原理:鼠标离开触发项后,延迟 ~300ms 再让菜单回归主题原本的显隐;这期间用内联 !important
   同时强制 display/opacity/visibility/pointer-events 可见(覆盖任何隐藏方式),给用户斜穿间隙的时间;
   指针回到触发项或面板则取消。只在交互瞬间存在内联样式、事后清除。
   配置:window.__MHF = { item:'CSS选择器(顶级导航项)', panel:'相对item内的面板选择器' , delay:300 }  */
(function () {
  if (window.__menuHoverFix) return; window.__menuHoverFix = 1;
  var CFG = window.__MHF || {};
  var ITEM = CFG.item, PANEL = CFG.panel, DELAY = CFG.delay || 300;
  if (!ITEM || !PANEL) return;
  var PIN = 'display:block!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important';

  function each(fn) { Array.prototype.forEach.call(document.querySelectorAll(ITEM), fn); }

  function pin(p) { if (p) { p.setAttribute('data-mhf-pin', '1'); p.style.cssText += ';' + PIN; } }
  function unpin(p) {
    if (p && p.getAttribute('data-mhf-pin')) {
      p.removeAttribute('data-mhf-pin');
      // 移除我们加的强制项,恢复主题原样
      p.style.display = ''; p.style.opacity = ''; p.style.visibility = ''; p.style.pointerEvents = '';
    }
  }

  function enhance() {
    each(function (it) {
      if (it.__mhf) return;
      var p = it.querySelector(PANEL);
      if (!p) return;
      it.__mhf = 1;
      var cancel = function () { if (it.__t) { clearTimeout(it.__t); it.__t = null; } };
      var enter = function () { cancel(); unpin(p); };           // 回到菜单:取消延迟,交回主题原生 :hover/JS
      var leave = function () {                                    // 离开菜单:先钉住可见,再延迟解钉
        cancel(); pin(p);
        it.__t = setTimeout(function () { unpin(p); it.__t = null; }, DELAY);
      };
      it.addEventListener('mouseenter', enter);
      it.addEventListener('mouseleave', leave);
      p.addEventListener('mouseenter', enter);   // 面板即使不是 item 后代也能取消
      p.addEventListener('mouseleave', leave);
    });
  }

  if (document.readyState !== 'loading') enhance(); else document.addEventListener('DOMContentLoaded', enhance);
  try { new MutationObserver(function () { enhance(); }).observe(document.body || document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
